import React, { ReactNode } from 'react';
import { Footer } from './footer';

import {
  LayoutControlContextProvider,
  useLayoutContext,
  useLayoutControlContext,
} from '../contexts';
import { cn } from '../utils';
import { PageHeading } from './page-heading';
import Tabs from './tabs';
import { Topbar } from './topbar';

function LayoutContent({ children }: { children: ReactNode }) {
  const { sidebarOpen } = useLayoutControlContext();
  // to 'close' sidebar if there is none
  const { sidebar, hideTabs, hideHeader } = useLayoutContext();

  const needsSidebarSpace = sidebar && sidebarOpen;

  return (
    <div
      className={cn(
        'flex flex-1 flex-col transition-all ease-in-out duration-300 origin-left min-h-[87vh] mt-[0px]',
        {
          'md:pl-[272px]': needsSidebarSpace,
          'pl-0': !needsSidebarSpace,
        }
      )}
    >
      <main className="flex-1 py-6">
        <PageHeading />
        {!hideTabs && <Tabs />}
        <div className={'max-w-full mx-auto py-4'}>{children}</div>
      </main>
    </div>
  );
}

export const Layout = ({ children }: { children?: ReactNode }) => {
  const { sidebar } = useLayoutContext();

  return (
    <LayoutControlContextProvider>
      <div data-testid="layout-container">
        <Topbar />
        {sidebar}
        <LayoutContent>{children}</LayoutContent>
        <Footer />
      </div>
    </LayoutControlContextProvider>
  );
};
